import { postIndexFile } from '../api/files'
import { createPresignedUrl, uploadFile } from '../api/record'
import { FileLifeType } from '../swagger/dtoGateway'

export const getFileName = (name: string, removeType = true) => {
    if (!removeType) return name

    const arr = name.split('.')
    arr.pop()

    return arr.join('.')
}

export const getFileType = (name: string) => name.split('.').pop() ?? ''

export const handleUploadFileToStorage = async (idEntity: string | number, file: File) => {
    if (file?.isLoaded) {
        await postIndexFile({
            prefix: file.prefix,
            rag_enabled: true,
            thread_id: +idEntity,
        })
        return file.url
    } else {
        const name = file.name.replace(/[<>@#*+^,${}=|[\]\\]/g, '').replace(/\s+/g, '_')
        const response = await createPresignedUrl({
            filename: `${idEntity}/${name}`,
            life_type: FileLifeType.PERMANENT,
        })

        const formData = new FormData()
        Object.entries(response.fields ?? {}).forEach(([key, value]) => {
            formData.append(key, value)
        })
        formData.append('file', file)
        await uploadFile({ url: response.url, formData })
        await postIndexFile({ prefix: `/${idEntity}/${name}`, rag_enabled: true })
        return response?.future_url ?? ''
    }
}
